import { render, staticRenderFns } from "./Relais.vue?vue&type=template&id=168c64d5&scoped=true&"
import script from "./Relais.vue?vue&type=script&lang=js&"
export * from "./Relais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c64d5",
  null
  
)

export default component.exports